import UPButton from 'components/button';
import { UPTanStackTableColumn } from 'components/tanstack-table';
import { TFunction } from 'i18next';
import {
  CONTRACT_COMPLIANCE__SCOPE_ENTITY,
  CONTRACT_COMPLIANCE__SCOPE_LEVEL,
  CONTRACT_COMPLIANCE__VALUE,
  GENERAL__EDIT,
} from 'translations/constants';
import { IRuleException } from 'types/contract-compliance/IContractCompliance';
import { SCOPE_LEVEL_LABEL_KEYS } from './constants';
import { getScopeEntityLabel } from './utils';

/** Read-only rows ending with an Edit button (exception list pattern). Exceptions carry no value column. */
export const buildExceptionColumns = (
  t: TFunction,
  testIdPrefix: string,
  onEdit: (row: IRuleException) => void,
  formatValue?: (row: IRuleException) => string,
): UPTanStackTableColumn<IRuleException>[] => {
  const valueColumns: UPTanStackTableColumn<IRuleException>[] = formatValue
    ? [
        {
          id: 'value',
          header: t(CONTRACT_COMPLIANCE__VALUE),
          cell: ({ row }) => <span data-testid={`${testIdPrefix}-value-${row.id}`}>{formatValue(row)}</span>,
        },
      ]
    : [];
  return [
    {
      id: 'scopeLevel',
      header: t(CONTRACT_COMPLIANCE__SCOPE_LEVEL),
      cell: ({ row }) => (
        <span data-testid={`${testIdPrefix}-scope-level-${row.id}`}>{t(SCOPE_LEVEL_LABEL_KEYS[row.scopeLevel])}</span>
      ),
    },
    {
      id: 'scopeEntity',
      header: t(CONTRACT_COMPLIANCE__SCOPE_ENTITY),
      cell: ({ row }) => (
        <span data-testid={`${testIdPrefix}-scope-entity-${row.id}`}>{getScopeEntityLabel(t, row)}</span>
      ),
    },
    ...valueColumns,
    {
      id: 'edit',
      header: '',
      enableSorting: false,
      align: 'right',
      cell: ({ row }) => (
        <UPButton
          text={t(GENERAL__EDIT)}
          outlined
          onClick={() => onEdit(row)}
          testId={`${testIdPrefix}-edit-${row.id}`}
        />
      ),
    },
  ];
};
